import { useGetOrganisationsQuery } from "./useGetOrganisationsQuery";

export const useGetOrganisationById = (id?: number) => {
  const { data } = useGetOrganisationsQuery();

  //we have Basemap org. with Id=0, so make sure tho check id with undefined not like this (id ? ... : ...)
  return data?.resources.find(org => org.organisationId === id);
};
